import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import graduateBackground from '../assets/Adsız tasarım (25).png';

const Graduate = () => {
    const navigate = useNavigate();
    const [timeLeft, setTimeLeft] = useState({
        days: 45,
        hours: 12,
        minutes: 30,
        seconds: 15
    });

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev.seconds > 0) {
                    return { ...prev, seconds: prev.seconds - 1 };
                } else if (prev.minutes > 0) {
                    return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
                } else if (prev.hours > 0) {
                    return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
                } else if (prev.days > 0) {
                    return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
                }
                return prev;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const scrollToDetails = () => {
        window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
        });
    };

    return (
        <div className="min-h-screen relative overflow-hidden">
            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(${graduateBackground})`
                }}
            ></div>

            {/* Floating Graduation Elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                {/* Graduation Caps */}
                <div className="absolute top-20 left-10 opacity-30 animate-float-slow">
                    <svg className="w-12 h-12 text-yellow-300" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
                    </svg>
                </div>
                <div className="absolute top-32 right-16 opacity-40 animate-float-delayed">
                    <svg className="w-8 h-8 text-yellow-400" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
                    </svg>
                </div>
                {/* Stars */}
                <div className="absolute top-16 right-20 opacity-50 animate-pulse-slow">
                    <svg className="w-6 h-6 text-yellow-300" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                </div>
                <div className="absolute bottom-32 left-16 opacity-40 animate-pulse-slow animation-delay-1000">
                    <svg className="w-4 h-4 text-yellow-400" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                </div>
            </div>

            {/* Main Graduation Card */}
            <section className="min-h-screen flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8 relative z-10">
                {/* Back Button */}
                <button
                    onClick={() => navigate('/calismalarimiz')}
                    className="absolute top-8 left-8 z-20 bg-white/95 backdrop-blur-md text-gray-700 p-3 rounded-full shadow-xl hover:bg-white hover:shadow-2xl transition-all duration-300 transform hover:scale-110 group"
                >
                    <svg className="w-6 h-6 group-hover:-translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                </button>

                {/* Graduation Invitation Card */}
                <div className="max-w-lg mx-auto w-full relative">
                    <div className="bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl overflow-hidden animate-slide-up border border-white/30">
                        {/* Card Content */}
                        <div className="p-8">
                            {/* Graduation Header */}
                            <div className="text-center mb-8 animate-slide-up" style={{ animationDelay: '0.2s' }}>
                                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-amber-500 rounded-full mx-auto mb-4 flex items-center justify-center shadow-lg">
                                    <svg className="w-8 h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
                                    </svg>
                                </div>
                                <h1 className="text-3xl font-bold text-gray-800 mb-2">Mezuniyet Töreni</h1>
                                <p className="text-lg text-blue-600 font-semibold">Sınıf 2024</p>
                            </div>

                            {/* Graduate Info */}
                            <div className="text-center mb-6 animate-slide-up" style={{ animationDelay: '0.4s' }}>
                                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
                                    <h2 className="text-2xl font-bold text-gray-800 mb-2">Özel Mezuniyet Töreni Davetiyesi</h2>
                                    <p className="text-gray-600 mb-4">
                                        "Eğitim yolculuğumuzun sonuna gelirken, yeni başlangıçlar için bir araya geliyoruz"
                                    </p>
                                    <div className="flex justify-center space-x-4 text-sm text-gray-500">
                                        <span>• Anılar</span>
                                        <span>• Video</span>
                                        <span>• Sertifika</span>
                                        <span>• Kutlama</span>
                                    </div>
                                </div>
                            </div>

                            {/* Date and Time */}
                            <div className="text-center mb-6 animate-slide-up" style={{ animationDelay: '0.6s' }}>
                                <div className="border-t border-gray-200 pt-6">
                                    <p className="text-2xl font-bold text-gray-800 mb-1">28 Haziran 2024 Cuma</p>
                                    <p className="text-lg text-gray-600">Saat 14:00</p>
                                </div>
                            </div>

                            {/* Countdown Timer */}
                            <div className="mb-6 animate-slide-up" style={{ animationDelay: '0.8s' }}>
                                <div className="text-center mb-4">
                                    <h3 className="text-lg font-semibold text-gray-700 mb-2">Mezuniyet Törenine Kalan Süre</h3>
                                </div>
                                <div className="grid grid-cols-4 gap-2">
                                    <div className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl p-3 text-center text-white">
                                        <span className="text-2xl font-bold block">{timeLeft.days}</span>
                                        <span className="text-xs uppercase tracking-wider">Gün</span>
                                    </div>
                                    <div className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl p-3 text-center text-white">
                                        <span className="text-2xl font-bold block">{String(timeLeft.hours).padStart(2, '0')}</span>
                                        <span className="text-xs uppercase tracking-wider">Saat</span>
                                    </div>
                                    <div className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl p-3 text-center text-white">
                                        <span className="text-2xl font-bold block">{String(timeLeft.minutes).padStart(2, '0')}</span>
                                        <span className="text-xs uppercase tracking-wider">Dakika</span>
                                    </div>
                                    <div className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl p-3 text-center text-white">
                                        <span className="text-2xl font-bold block">{String(timeLeft.seconds).padStart(2, '0')}</span>
                                        <span className="text-xs uppercase tracking-wider">Saniye</span>
                                    </div>
                                </div>
                            </div>

                            {/* Venue */}
                            <div className="text-center mb-8 animate-slide-up" style={{ animationDelay: '1s' }}>
                                <p className="text-gray-600 text-sm font-medium">
                                    İstanbul Kongre Merkezi<br />
                                    Harbiye Mahallesi, Darülbedayi Cd. No:3 Şişli/İstanbul
                                </p>
                            </div>

                            {/* Action Button */}
                            <div className="text-center animate-slide-up" style={{ animationDelay: '1.2s' }}>
                                <button
                                    onClick={scrollToDetails}
                                    className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                                >
                                    Detayları Görüntüle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Event Details Section */}
            <section className="py-16 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 relative overflow-hidden">
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-8 left-4 opacity-10 animate-float">
                        <svg className="w-12 h-12 text-blue-400" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
                        </svg>
                    </div>
                    <div className="absolute bottom-16 right-8 opacity-15 animate-float-delayed">
                        <svg className="w-16 h-16 text-indigo-400" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                        </svg>
                    </div>
                </div>

                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="text-center mb-12">
                        <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4 animate-slide-up">
                            🎓 Mezuniyet Töreni Detayları
                        </h2>
                        <p className="text-base text-gray-600 leading-relaxed animate-slide-up" style={{ animationDelay: '0.2s' }}>
                            Birlikte geçirdiğimiz güzel anıları kutlayacağımız özel törenimiz
                        </p>
                    </div>

                    {/* Program Cards */}
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-white/30 animate-slide-up" style={{ animationDelay: '0.4s' }}>
                            <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mb-4">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Program</h3>
                            <p className="text-gray-600 text-sm">14:00 - Karşılama</p>
                            <p className="text-gray-600 text-sm">14:30 - Tören Başlangıcı</p>
                            <p className="text-gray-600 text-sm">15:30 - Diploma Töreni</p>
                            <p className="text-gray-600 text-sm">16:30 - Kutlama</p>
                        </div>

                        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-white/30 animate-slide-up" style={{ animationDelay: '0.6s' }}>
                            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mb-4">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Fotoğraf</h3>
                            <p className="text-gray-600 text-sm">Profesyonel fotoğraf çekimi</p>
                            <p className="text-gray-600 text-sm">Sınıf fotoğrafları</p>
                            <p className="text-gray-600 text-sm">Anı defteri</p>
                            <p className="text-gray-600 text-sm">Dijital galeri</p>
                        </div>

                        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-white/30 animate-slide-up" style={{ animationDelay: '0.8s' }}>
                            <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mb-4">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Sertifika</h3>
                            <p className="text-gray-600 text-sm">Diploma teslimi</p>
                            <p className="text-gray-600 text-sm">Başarı belgeleri</p>
                            <p className="text-gray-600 text-sm">Onur listesi</p>
                            <p className="text-gray-600 text-sm">Katılım sertifikası</p>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="grid md:grid-cols-2 gap-4 animate-slide-up" style={{ animationDelay: '1s' }}>
                        <button
                            onClick={() => window.open('https://maps.google.com/?q=İstanbul+Kongre+Merkezi+Harbiye+Mahallesi+Darülbedayi+Cd+No:3+Şişli+İstanbul', '_blank')}
                            className="group bg-gradient-to-r from-blue-600 to-blue-700 text-white p-4 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                        >
                            <div className="flex items-center justify-center space-x-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <div className="text-left">
                                    <h3 className="text-lg font-bold">Yol Tarifi Al</h3>
                                    <p className="text-blue-100 text-sm">Google Haritalar'da Aç</p>
                                </div>
                            </div>
                        </button>

                        <a
                            href="tel:+905551234567"
                            className="group bg-gradient-to-r from-green-600 to-emerald-700 text-white p-4 rounded-xl hover:from-green-700 hover:to-emerald-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 block"
                        >
                            <div className="flex items-center justify-center space-x-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                                <div className="text-left">
                                    <h3 className="text-lg font-bold">İletişime Geç</h3>
                                    <p className="text-green-100 text-sm">+90 555 123 4567</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-gradient-to-br from-blue-100 via-indigo-50 to-purple-100 py-10 relative overflow-hidden">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="text-center">
                        <div className="flex justify-center mb-4">
                            <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                                <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
                                </svg>
                            </div>
                        </div>

                        <h2 className="text-2xl lg:text-3xl font-serif text-gray-900 mb-6">
                            Sınıf 2024
                        </h2>

                        <div className="bg-white/60 backdrop-blur-sm rounded-xl p-6 border border-blue-200/50 shadow-lg mb-8">
                            <p className="text-gray-600 leading-relaxed italic">
                                "Öğrenmenin sonu yoktur, mezuniyet sadece yeni bir başlangıçtır."
                            </p>
                        </div>

                        <div className="pt-6 border-t border-blue-200/50">
                            <div className="flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500">
                                <p className="mb-2 sm:mb-0">
                                    © 2024 Sınıf Mezuniyet Töreni
                                </p>
                                <div className="flex items-center space-x-2">
                                    <span>Powered by</span>
                                    <span className="font-semibold text-blue-600">DijiVite</span>
                                    <svg className="w-3 h-3 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Graduate;
